import { render, staticRenderFns } from "./PreviewPlayer.vue?vue&type=template&id=6b4e1aea&scoped=true&"
import script from "./PreviewPlayer.vue?vue&type=script&lang=js&"
export * from "./PreviewPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPlayer.vue?vue&type=style&index=0&id=6b4e1aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e1aea",
  null
  
)

export default component.exports